module.exports = __webpack_public_path__ + "static/media/404-bg.deb052a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/404-bg.png
// module id = 259
// module chunks = 270